import mixpanel from 'mixpanel-browser';
import * as R from 'ramda';

const isUserTrackingCookiesDisabled = (typeof window === 'undefined') ? undefined : R.path(['_infl', 'hub', 'isUserTrackingCookiesDisabled'], window);

const nameSpaceKeys = o => Object.keys(o).reduce((acc, curr) => {
  acc[`current_contact_${curr}`] = o[curr];
  return acc;
}, {});

export default {
  init: (token) => {
    let tracking_options = {};
    if (isUserTrackingCookiesDisabled) {
      tracking_options = {
        opt_out_tracking_by_default: true,
        opt_out_persistence_by_default: true
      };
    }

    mixpanel.init(token, tracking_options);
  },
  track: (eventName, props) => {

    let defaultProps = {};
    if (window && window._infl) {
      defaultProps = {
        subdomain: window._infl.hub.subdomain,
        ...nameSpaceKeys(window._infl.currentContact)
      };
    }
    return mixpanel.track(eventName, { ...defaultProps, ...props });
  }
};
